module.exports = __webpack_public_path__ + "static/media/service-details-promo1.9185dc13.png";